import type * as ReactRouter from "react-router";
import { SecurityPage } from "~/app/components/landing/security-page";
import { t } from "~/app/i18n";

export const meta: ReactRouter.MetaFunction = () => [
  { title: t("Security.metaTitle") },
  { name: "description", content: t("Security.metaDescription") },
];

export default function SecurityPL() {
  return <SecurityPage locale="pl" />;
}
